import { Trans, useTranslation } from "react-i18next"
import classes from "../SeedLister.module.css"
import img_ordered from "../../../assets/images/img_ordered.png"
import img_received from "../../../assets/images/img_received.png"
import img_enter from "../../../assets/images/img_enter.png"
import img_enter_pre from "../../../assets/images/img_order1.png"

const Tutorial = props => {
    const { t } = useTranslation()

    return (
        <div className={classes.Wrapper}>
            <h2>{t("misc:Navigation.Tutorial")}</h2>
            <ol>
                <li>
                    <p>{t("misc:SeedListing.MurchOrderHeadline")}:</p>
                    <p>{t("misc:SeedListing.MurchOrderDesc")}.</p>
                    <img src={img_ordered} alt="ordered" width={300} />
                </li>
                <li>
                    <p>{t("misc:SeedListing.MurchOrderEnterHeadline")}:</p>
                    <p>{t("misc:SeedListing.MurchOrderEnterDesc")}.</p>
                    <img src={img_enter_pre} alt="ordered" width={300} />
                </li>
                <li>
                    <p>{t("misc:SeedListing.MurchReceiveHeadline")}:</p>
                    <p>{t("misc:SeedListing.MurchReceiveDesc")}</p>
                    <img src={img_received} alt="received" width={300} />
                </li>
                <li>
                    <p>{t("misc:SeedListing.MurchReceiveEnterHeadline")}:</p>
                    <p>
                        <Trans
                            i18nKey="misc:SeedListing.MurchReceiveEnterDesc"
                            defaults={
                                "Enter the order and what you received on the bottom. All empty slots should be marked as <0>?</0>. Also make sure to tick the <0>Received</0> checkbox."
                            }
                            components={[<code />]}
                        />
                    </p>
                    <img src={img_enter} alt="enter result" width={400} />
                </li>
            </ol>
        </div>
    )
}

export default Tutorial
